<template>
    <div class="flex min-w-0 flex-1 items-center">
      <span class="mr-2.5 shrink-0 whitespace-nowrap">{{ $t(item.label) }}</span>
      <i v-if="item.icon" class="tr mr-1.25 shrink-0" :class="`tr-${item.icon}`"></i>
      <ProjectAvatar
        v-if="item.project"
        class="mr-2.5 h-7 w-10 shrink-0 rounded-[3px] [text-shadow:2px_2px_7px_var(--shadow-color)]"
        :project="item.project"
      />
      <UserAvatar withDayoffBadge v-if="item.user" :user="item.user" class="mr-2.5 inline-flex! shrink-0"/>
      <TagIcon class="mr-2.5 shrink-0" v-if="item.tag !== undefined" :tag="item.tag" />
      <span class="min-w-0 overflow-hidden text-ellipsis whitespace-pre">
        <span class="whitespace-pre">{{item.textBefore}}</span>
        <span class="whitespace-pre rounded-[3px] bg-accent-soft p-0">{{item.textSelected}}</span>
        <span class="whitespace-pre">{{item.textAfter}}</span>
      </span>
      <span
        class="ml-2.5 shrink-0 whitespace-nowrap text-accent"
        v-if="item.inProject && project && project.name"
      >
          {{ $t('search.in') }} {{project.name}}
      </span>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import TagIcon from '@/components/elements/TagIcon';
import ProjectAvatar from '@/components/elements/ProjectAvatar';

defineProps({
  item: {
    type: Object,
  },
});

const store = useStore();

const project = computed(() => store.state.project.project);
</script>
